<template>
    <div class="select-date-time__container">
        <div class="card__inner select-date-time__card-flex">
            <div class="select-date-time__container">
                <div class="select-date-time__top">
                    <div class="flatpickr">
                        <input
                            type="text"
                            name="date"
                            ref="date"
                            id="date"
                            class="form-control form-control--select select-date-time__select-input select-date-time__select-input"
                            :value="formattedDate"
                            placeholder="Please select a date"
                        />
                        <button class="input-button" @click="toggleDateSelect"></button>
                    </div>
                </div>

                <LoadingSpinner v-if="loading"/>
                <template v-else >
                    <div v-if="timesForSelectedDate && timesForSelectedDate !== 'closed'" class="select-date-time__bottom">
                        <p  v-if="!validationMessage" class="select-date-time__times-title">Please select a timeslot: </p><p v-else class="select-date-time__times-title select-date-time__validation-error">{{ validationMessage }}</p>
                        <p  v-if="bookingExists === true"  class="select-date-time__validation-error">{{ bookingExistsMessage }}</p>
                        <div class="select-date-time__times-container">
                            <div v-for="(time, index) in timesForSelectedDate" :key="index" class="select-date-time__times-tile" :class="{ selected: selectedTime === time }" v-on:click="setTime(time)">
                                <input type="radio" :id="time.split(' ').join('')" name="bookingTime" :value="time.split(' ').join('')" class="select-date-time__radio-input"  @click="goToPositionMobile('book-appointment-button')" />
                                <label :for="time.split(' ').join('')" class="find-my-car__time-label"> {{ time }} </label>
                            </div>
                        </div>
                    </div>

                    <div v-if="timesForSelectedDate == 'closed'" class="select-date-time__dealer-closed">This dealership is closed on this day, please select another day.</div>
                    <button id="book-appointment-button" type="button" class="btn btn--primary card__button" @click.prevent="next_step">Book an appointment</button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex/dist/vuex.esm.browser";
import LoadingSpinner from "../../../core/components/LoadingSpinner.vue";

export default {
    components: {
        LoadingSpinner,
    },

    props: {
        serviceType: {
            type:String,
            default:'sales'
        }
    },

    data() {
        return {
            isMounted: false,
            validationMessage: false,
            flatpickrInstance: false,
            dealerTimes: false,
            timesForSelectedDate: null,
        };
    },

    computed: {
        ...mapState("Dealers", ["selectedDealer", "loading", "closedDays"]),
        ...mapState("ValuationTool", ["selectedDate", "selectedTime", "registration", "bookingExists", "bookingExistsMessage", "loading"]),

        formattedDate() {
            return this.selectedDate ? new Date(this.selectedDate).toDateString() : "";
        },
    },

    watch: {
        selectedTime(val) {
            if (val && this.selectedDate) {
                this.validationMessage = false;
            }
        },
        selectedDealer(newValue) {
            if (newValue && newValue.id) {
                this.getClosedDays(this.serviceType)
                .then(() => this.getFirstBookableDateFromAPI())
            }
        }
    },

    methods: {
        ...mapMutations("Dealers", ["setMaxDate"]),
        ...mapMutations("ValuationTool", ["setSelectedDate", "setSelectedTime"]),
        ...mapActions("Dealers", ["getClosedDays", "getFirstBookableDate"]),
        ...mapActions("ValuationTool", ["bookAppointment", "goToPosition"]),

        goToPositionMobile() {
            if (window.innerWidth <= 768) {
                this.goToPosition('book-appointment-button');
            }
        },

        initializeDatePicker() {
            if (this.flatpickrInstance !== false) {
                return;
            }

            this.flatpickrInstance = flatpickr(this.$refs.date, {
                minDate: this.selectedDealer.minDate,
                maxDate: this.selectedDealer.maxDate,
                altInput: false,
                dateFormat: "D J F Y",
                locale: { firstDayOfWeek: 1 },
                disable: [
                    (date) => this.closedDays.some(closedDay => closedDay.toDateString() === date.toDateString()),
                ],
                onChange: ([selectedDate]) => {
                    this.setSelectedDate(selectedDate);
                    this.getDealerOpeningTimes();
                },
            });
        },


        toggleDateSelect() {
            this.flatpickrInstance.open();
        },

        getDealerOpeningTimes() {
            axios.get('/api/dealer-opening-times', {
                params: {
                    dealer: this.selectedDealer.id,
                    service_type: this.serviceType,
                    interval: '15 minutes',
                    date: this.selectedDate,
                }
            })
            .then((response) => {
                this.dealerTimes = response.data;
                this.timesForSelectedDate = this.dealerTimes;

                if (!this.isMounted) {
                    this.initializeDatePicker();
                }
            })
            .catch((error) => {
                this.throwFatalError();
            });
        },

        setTime(time) {
            this.setSelectedTime(time);
        },

        next_step() {
            if (!this.selectedDate || !this.selectedTime) {
                this.validationMessage = "Please select a date & time";
                return;
            }
            this.bookAppointment()
            this.goToPosition('booking-details')
            // new EventObject("OSB", "Click", "Select date and time continue clicked").dispatch();
        },
        setMaxDates() {
            const maxDate = new Date();
            maxDate.setMonth(maxDate.getMonth() + 6);
            this.setMaxDate(maxDate);
        },
        getFirstBookableDateFromAPI() {
            this.getFirstBookableDate(this.serviceType)
            .then(() => {
                this.initializeDatePicker(); // Initialize after getting the minDate
            })
            .catch(error => {
                console.error('Error fetching first bookable date:', error);
            });
        },
    },

    mounted() {
        this.isMounted = true;
        this.setMaxDates();
        if(this.selectedDealer.id){
            this.getClosedDays(this.serviceType)
            .then(() => this.getFirstBookableDateFromAPI())
        }
    },
};
</script>

<style lang="scss" scoped>
.selected {
    border-color: #0293d6;
    color: #0293d6;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/SelectDateTime.vue